import DZYSLX from './dzyslx'
import DzyslxUtil from './DzyslxUtil'
import DicConst from '../dict/DicConst'
import DictUtil from '../dict/DictUtil'
import DictMgr from '../dict/DictMgr'

window.DZYSLX = DZYSLX
window.DzyslxUtil = DzyslxUtil

window.DicConst = DicConst
window.DictUtil = DictUtil
window.DictMgr = new DictMgr()

